import axios from 'axios';

// Same-origin: Nginx (prod) e Vite (dev) fazem proxy de /api para o backend.
const api = axios.create({
  baseURL: '/api',
  withCredentials: true,
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const status: number | undefined = error.response?.status;

    if (status === 401) {
      // if unauthorized, redirect to login and clear user data
      window.location.href = '/';
      localStorage.removeItem('user');
    }
    return Promise.reject(error);
  }
);

export default api;
